export default __webpack_public_path__ + "static/media/lu.f40a3315.svg";